export class Vendor {
  VendorName: string;
  VendorId: number;

  constructor(obj: any) {
    this.VendorId = obj.id;
    this.VendorName = obj.vendorName;
  }
}
